import { createBooleanTagManager } from '../../utils/createBooleanTagManager';

export const suburbanHouseTypeTagManager = createBooleanTagManager({
  jsonQueryKey: 'is_dacha',
  trueLabel: 'Тип дома: Дача',
  falseLabel: 'Тип дома: Для постоянного проживания',
  id: 'suburbanHouseType',
});
